import React from 'react';
import { inc } from 'ramda';
import styled, { css } from 'styled-components';

const barLevel1Mixin = css`
  background: #d1462f;
  width: 20%;
`;
const barLevel2Mixin = css`
  background: #d1462f;
  width: 40%;
`;
const barLevel3Mixin = css`
  background: #57b8ff;
  width: 60%;
`;
const barLevel4Mixin = css`
  background: #57b8ff;
  width: 80%;
`;
const barLevel5Mixin = css`
  background: #2fbf71;
  width: calc(100% + 2px);
`;

const StyledBar = styled(({ strength, ...rest }) => <div {...rest} />)<{
  strength: number;
}>`
  box-sizing: border-box;
  height: 3px;
  position: relative;
  top: 1px;
  right: 1px;
  transition: width 300ms ease-out;
  width: 0;
  ${(p) => p.strength === 1 && barLevel1Mixin};
  ${(p) => p.strength === 2 && barLevel2Mixin};
  ${(p) => p.strength === 3 && barLevel3Mixin};
  ${(p) => p.strength === 4 && barLevel4Mixin};
  ${(p) => p.strength === 5 && barLevel5Mixin};
`;

const hasNumber = (value: string) => /[0-9]/.test(value);
const hasMixed = (value: string) => /[a-z]/.test(value) && /[A-Z]/.test(value);
const hasSpecial = (value: string) => /[!#@$%^&*)(+=._-]/.test(value);

export const strengthIndicator = (value?: string) => {
  let strength = 0;
  if (!value) {
    return strength;
  }
  if (value.length >= 1) strength = inc(strength);
  if (value.length > 8) strength = inc(strength);
  if (hasNumber(value)) strength = inc(strength);
  if (hasSpecial(value)) strength = inc(strength);
  if (hasMixed(value)) strength = inc(strength);
  return strength;
};

interface Props {
  password?: string;
}

const PasswordStrengthBar: React.FC<Props> = ({ password }) => (
  <StyledBar strength={strengthIndicator(password)} />
);

export default PasswordStrengthBar;
